import { useDialogContext } from '@ariakit/react'
import React from 'react'

import { useLmfAnalyticsOnClick } from '@syconium/little-miss-figgy'

import { NextLink } from '../../../../app/_components/navigation/NextLink'

import * as Styles from './styles'

type ColorGalleryTileProps = {
  colorDisplayValue: string
  colorKey: string
  imageUrl: string
  altText?: string | null
  pdpUrl: string
  onSelectColor?: ((colorKey: string) => void) | undefined
}

// Extracted to prevent nesting hooks
const ColorGalleryTile = ({
  colorDisplayValue,
  colorKey,
  imageUrl,
  altText,
  pdpUrl,
  onSelectColor,
}: ColorGalleryTileProps) => {
  const dialogContext = useDialogContext()

  const onClick = () => {
    onSelectColor?.(colorKey)
    dialogContext?.hide()
  }

  const onClickWithTracking = useLmfAnalyticsOnClick({
    element: 'tile',
    variations: ['color-gallery'],
    label: colorDisplayValue,
    href: pdpUrl,
    onClick,
  })

  const tileContent = (
    <>
      <Styles.Tile
        src={imageUrl}
        alt={altText || `${colorDisplayValue} image`}
        loading='lazy'
        widths={{
          unit: 'px',
          sm: 150,
          md: 150,
        }}
        aspectRatios={{
          sm: 1,
          md: 1,
        }}
      />
      <Styles.TileName>{colorDisplayValue}</Styles.TileName>
    </>
  )

  return onSelectColor ? (
    <Styles.TileButton type='button' onClick={onClickWithTracking}>
      {tileContent}
    </Styles.TileButton>
  ) : (
    <NextLink href={pdpUrl} onClick={onClickWithTracking}>
      {tileContent}
    </NextLink>
  )
}

export default ColorGalleryTile
